import { createSlice } from '../wrappers';

export enum AuthTabs {
	Login = 'login',
	Restore = 'restore',
	RestoreNewPassword = 'restoreNewPassword',
	Register = 'register',
	ConfirmEmail = 'confirmEmail',
}

interface AuthTabsSlice {
	activeTab: AuthTabs;
	confirmTimer: number;
	emailConfirm: 'register' | 'restore';
}

const initialState: AuthTabsSlice = {
	activeTab: AuthTabs.Login,
	confirmTimer: 0,
	emailConfirm: 'register',
};

const authTabsSlice = createSlice({
	name: 'authTabs',
	initialState,
	reducers: {
		setActiveTab: (state, action) => {
			const nextTab = action.payload;
			state.activeTab = nextTab;
		},
		setConfirmTimer: (state, action) => {
			state.confirmTimer = action.payload;
		},
		setEmailConfirm: (state, action) => {
			state.emailConfirm = action.payload;
		},
	},
});

export const { setActiveTab, setConfirmTimer, setEmailConfirm } =
	authTabsSlice.actions;

export default authTabsSlice.reducer;
